module.exports = __webpack_public_path__ + "/images/shop/icon/catalog/fuel_preparation_system.svg";